import { createSlice, PayloadAction } from "@reduxjs/toolkit";

interface ItemConnectedInterface {
  itemConnected: boolean;
}

const initialState: ItemConnectedInterface = {
  itemConnected: false,
};

const itemConnectedSlice = createSlice({
  name: "itemConnected",
  initialState,
  reducers: {
    setItemConnected: (state, action: PayloadAction<boolean>) => {
      state.itemConnected = action.payload;
    },
  },
});

export const { setItemConnected } = itemConnectedSlice.actions;
export default itemConnectedSlice.reducer;
